<template>
  <v-card :style="backOpacity">
    <v-card-title>自動番号フォーム</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="ラベル名"
                v-model="returnData.label"
                :rules="[validation.required]"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <set-Cols
                :value="String(returnData.cols)"
                v-on:set="$set(returnData, 'cols', $event)"
              ></set-Cols>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-select
                :items="selectType"
                v-model="values[0]"
                label="自動番号タイプ"
                item-text="text"
                item-value="value"
                :rules="[validation.required]"
              ></v-select>
            </v-col>

            <v-col cols="3" v-if="values[0] == 'SerialNumber'">
              <v-text-field
                label="桁数"
                v-model="values[1]"
                :rules="[validation.numonly]"
              ></v-text-field
            ></v-col>
            <v-col cols="6" v-else-if="values[0] == 'ParentNumber'">
              <v-text-field
                label="親レポートのフォームID"
                v-model="values[1]"
                :rules="[validation.numonly]"
              ></v-text-field
            ></v-col>
            <v-col cols="6" v-else>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="フォーマット"
                    v-model="values[1]"
                    :rules="[validation.required]"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field
                ></template>
                <span>YYYY(年)-MM(月)-DD(日)-NNNN(自動番号)</span>
              </v-tooltip>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="メール送信時メッセージ位置(1=<)"
                v-model="values[2]"
                :rules="[]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        x-large
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import setCols from "./common/setCols.vue";
export default {
  components: {
    setCols,
  },
  props: {
    label: String,
    type: Number,
    cols: String,
    position: Number,
    //個別値
    value: String,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        type: this.type,
        cols: this.cols,
        position: this.position,
        //個別値
        value: this.value,
      },
      backOpacity: "opacity: 1",
      validation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        required: (value) => !!value || "必須項目です",
      },
      selectType: [
        { text: "DateNum", value: "DateNum" },
        { text: "DateNum2(ハイフンなし)", value: "DateNum2" },
        { text: "全体共通番号", value: "SerialNumber" },
        //{ text: "DateNum3(仮置き)", value: "DateNum3" },
        { text: "親レポートの自動番号を保存", value: "ParentNumber" },
      ],
      values: ["DateNum", "ABC-YYYY-MM-DD-NNNN"],
    };
  },
  mounted() {
    if (this.returnData.value != "") {
      this.values = this.value.split(",");
    }
  },
  methods: {
    submit() {
      console.log(this.$refs.form.validate());
      if (this.$refs.form.validate()) {
        this.returnData.value = this.values.join(",");
        this.$emit("clickSubmit", this.returnData);
      }
    },
  },
};
</script>
